// src/hooks/useTodos.js
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getTodos, addTodo, toggleTodo, deleteTodo, updateTodo } from "../api/todos";

export function useTodos() {
    return useQuery({ queryKey: ["todos"], queryFn: getTodos, retry: false });
}

export function useAddTodo() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: addTodo,
        onSuccess: () => qc.invalidateQueries({ queryKey: ["todos"] }),
    });
}

export function useToggleTodo() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ id, done }) => toggleTodo(id, done),
        onSuccess: () => qc.invalidateQueries({ queryKey: ["todos"] }),
    });
}

export function useDeleteTodo() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: deleteTodo,
        onSuccess: () => qc.invalidateQueries({ queryKey: ["todos"] }),
    });
}


export function useUpdateTodo() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ id, ...patch }) => updateTodo(id, patch),
        onSuccess: () => qc.invalidateQueries({ queryKey: ["todos"] }),
    });
}
